import { render, staticRenderFns } from "./add-dam-sire-container.vue?vue&type=template&id=4a4422c9&scoped=true&lang=pug"
import script from "./add-dam-sire-container.js?vue&type=script&lang=js&external"
export * from "./add-dam-sire-container.js?vue&type=script&lang=js&external"
import style0 from "./add-dam-sire-container.vue?vue&type=style&index=0&id=4a4422c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4422c9",
  null
  
)

export default component.exports